export default __webpack_public_path__ + "static/media/dashboard.893a0836.svg";